export default {"src":"/_next/static/media/blue-blob-ellipse.9362e578.svg","height":112,"width":86,"blurWidth":0,"blurHeight":0};